require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-impact-has-the-ifc-sponsored-hidrovias-do-brasil.json") })
        }
      }, "path---en-us-update-what-impact-has-the-ifc-sponsored-hidrovias-do-brasil");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-impact-has-the-ifc-sponsored-hidrovias-do-brasil!./.cache/json/en-us-update-what-impact-has-the-ifc-sponsored-hidrovias-do-brasil.json
// module id = 840
// module chunks = 231608221292675